import React, { Component, Suspense, lazy } from "react";
import ReactDOM from "react-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import { withStyles } from "@material-ui/core";

import { Input, Table, Dropdown, Menu } from "antd";
import { capitalize, isArray } from "lodash";
import moment from "moment";

import HUBContext from "../../../../services/HUBContext";
import hubAPI from "../../../../services/hubAPI";
import {
  generateUID,
  getHardFilter,
  setHardFilter,
} from "../../../../common/utils";
import {
  DV3CogIcon,
  DV3ExcelIcon,
  DV3SearchIcon,
  DV3EllipseIcon,
  DV3EditIcon,
  V3ShowDetails,
} from "../../../../common/icons";
import { Link } from "react-router-dom";
import { withAlert } from "react-alert";
import handleAPI from "../../../../helpers/handleAPI";
import { vehicleStatuses, ownershipStatuses } from "../../../../common/status";
import CustomColumns from "../../../../helpers/customColumns";
import { isSingleRegistryVehicleActive } from "../../../../services/api/hubcatalog/single-registry-service";

const LoadInWidget = lazy(() => import("../../../../helpers/loadInWidget"));
const CustomPaginator = lazy(
  () => import("../../../../helpers/customPaginator"),
);
const styles = (theme) => ({
  root: {},
  cuztomizeConfirm: {
    width: "300px",
    "& .ant-modal-confirm-btns": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "0px",
      gap: "16px",
      flex: "none",
      flexGrow: 0,
      "& .secondary": {
        order: 1,
      },
      "& .primary": {
        order: 0,
      },
      "& .v3-button": {
        margin: "0px !important",
      },
    },
  },
  cuztomizeSuccess: {
    "& .ant-modal-confirm-btns": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "0px",
      gap: "16px",
      flex: "none",
      flexGrow: 0,
      "& .v3-button": {
        margin: "0px !important",
        width: "auto",
      },
    },
  },
});

export class VehicleTableCardActions extends Component {
  render() {
    const { dashboardWidgetID } = this.props;
    const actionsContainer = document.getElementById(
      `widget-title-portal-${dashboardWidgetID}`,
    );
    if (!actionsContainer) return null;
    return ReactDOM.createPortal(this.props.children, actionsContainer);
  }
}

export const ActionsColumnMenu = ({
  vehicleID,
  companyID,
  reviewUrl,
  editUrl,
  ...menuProps
}) => (
  <Menu {...menuProps}>
    {!!editUrl && (
      <Menu.Item key={editUrl}>
        <Link
          to={editUrl
            .replace(":companyID", companyID || 0)
            .replace(":vehicleID", vehicleID || 0)}
        >
          <span className="icon-container">
            <DV3EditIcon />
          </span>

          <FormattedMessage
            id="vehicle.edit"
            defaultMessage="Edit"
          />
        </Link>
      </Menu.Item>
    )}

    {!!reviewUrl && (
      <Menu.Item key={reviewUrl}>
        <Link
          to={reviewUrl
            .replace(":companyID", companyID || 0)
            .replace(":vehicleID", vehicleID || 0)}
        >
          <span className="icon-container">
            <V3ShowDetails />
          </span>

          <FormattedMessage
            id="vehicle.details"
            defaultMessage="View details"
          />
        </Link>
      </Menu.Item>
    )}
  </Menu>
);

export class VehicleTableCardBase extends Component {
  _isMounted = false;
  state = {
    ready: false,
    loading: false,
    error: false,
    companyID: 0,
    response: null,
    search: "",
    visibleColumns: [
      "_attachments",
      "plate",
      "name",
      "vehicleStatus.name",
      "ownershipStatus.name",
      "hierarchy.name",
      "costCenter.name",
      "vehicleBrand.name",
      "year",
    ],
    stateuid: null,
    showCustomizeColumns: false,
    singleRegistryIsActive: false,
  };
  columnsSet = [];
  mount = false;

  prepareColumnSet() {
    const { intl } = this.props;

    this.columnsSet = [
      {
        dataIndex: "_attachments",
        title: intl.formatMessage({
          id: "vehicles.table.attachments",
          defaultMessage: "Attachments",
        }),
        width: 170,
        render: (_, record) => {
          const { companyID } = this.state;
          return (
            <Link
              to={`/app/${companyID}/vehicle/details/${record?.vehicleID || 0}/attachments`}
            >
              <FormattedMessage
                id="vehicles.table.show"
                defaultMessage="Show"
              />
            </Link>
          );
        },
      },
      {
        dataIndex: "plate",
        title: intl.formatMessage({ id: "plate", defaultMessage: "Plate" }),
        sorter: true,
        width: 170,
        render: (text, record) => {
          const { companyID } = this.state;
          return (
            <Link
              to={`/app/${companyID}/vehicle/details/${record?.vehicleID || 0}/info`}
            >
              {text}
            </Link>
          );
        },
      },
      {
        dataIndex: "name",
        title: intl.formatMessage({
          id: "vehicle.name",
          defaultMessage: "Vehicle name",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleStatus.name",
        title: intl.formatMessage({
          id: "vehicles.table.status",
          defaultMessage: "Status",
        }),
        sorter: true,
        width: 170,
        render: (text, record, _) => {
          return this.getVehicleStatus(text, record);
        },
      },
      {
        dataIndex: "ownershipStatus.name",
        title: intl.formatMessage({
          id: "vehicles.table.ownershipStatus",
          defaultMessage: "Ownership status",
        }),
        sorter: true,
        width: 170,
        render: (text, record, _) => {
          return this.getOwnershipStatus(text, record);
        },
      },
      {
        dataIndex: "hierarchy.name",
        title: intl.formatMessage({
          id: "hierarchy",
          defaultMessage: "Hierarchy",
        }),
        sorter: true,
        width: 200,
        ellipsis: true,
      },
      {
        dataIndex: "driver.managerName",
        title: intl.formatMessage({
          id: "driver.managerName",
          defaultMessage: "Manager name",
        }),
        sorter: true,
        width: 200,
        ellipsis: true,
      },
      {
        dataIndex: "driver.legalIdentification",
        title: intl.formatMessage({
          id: "drivers.legalIdentification",
          defaultMessage: "Legal Identification",
        }),
        sorter: true,
        width: 200,
        ellipsis: true,
      },
      {
        dataIndex: "costCenter.name",
        title: intl.formatMessage({
          id: "costCenter",
          defaultMessage: "Cost Center",
        }),
        sorter: true,
        width: 170,
        ellipsis: true,
      },
      {
        dataIndex: "costCenter.code",
        title: intl.formatMessage({
          id: "hierarchy.costCenterCode",
          defaultMessage: "Cost Center Code",
        }),
        sorter: true,
        width: 170,
        ellipsis: true,
      },
      {
        dataIndex: "vehicleBrand.name",
        title: intl.formatMessage({
          id: "vehicleBrand",
          defaultMessage: "Brand",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleModel.name",
        title: intl.formatMessage({
          id: "vehicleModel",
          defaultMessage: "Model",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleVersion.name",
        title: intl.formatMessage({
          id: "vehicleVersion",
          defaultMessage: "Version",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleType.name",
        title: intl.formatMessage({
          id: "vehicleType",
          defaultMessage: "Type",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "vehicleSubType.name",
        title: intl.formatMessage({
          id: "vehicleSubType",
          defaultMessage: "Sub-type",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "year",
        title: intl.formatMessage({ id: "year", defaultMessage: "Year" }),
        sorter: true,
        width: 130,
      },
      {
        dataIndex: "yearFabrication",
        title: intl.formatMessage({
          id: "yearFabrication",
          defaultMessage: "Fabrication year",
        }),
        sorter: true,
        width: 130,
      },
      {
        dataIndex: "fleetType.name",
        title: intl.formatMessage({
          id: "fleetType",
          defaultMessage: "Fleet type",
        }),
        sorter: true,
        width: 130,
      },
      {
        dataIndex: "purchaseDate",
        title: intl.formatMessage({
          id: "purchaseDate",
          defaultMessage: "Purchase date",
        }),
        sorter: true,
        width: 170,
        render: (text) => {
          if (!text) return "";
          return moment(text).format("L");
        },
      },
      {
        dataIndex: "passengers",
        title: intl.formatMessage({
          id: "passengers",
          defaultMessage: "Passengers",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "odometerCurrent",
        title: intl.formatMessage({
          id: "odometer",
          defaultMessage: "Odometer",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "horometerCurrent",
        title: intl.formatMessage({
          id: "horometer",
          defaultMessage: "Horometer",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "motorNumber",
        title: intl.formatMessage({
          id: "motorNumber",
          defaultMessage: "Motor number",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "chassisNumber",
        title: intl.formatMessage({
          id: "chassisNumber",
          defaultMessage: "Chassis number",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "color",
        title: intl.formatMessage({ id: "color", defaultMessage: "Color" }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "driver",
        title: intl.formatMessage({ id: "driver", defaultMessage: "Driver" }),
        render: (_, record) => record?.driver?.name,
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "axleQty",
        title: intl.formatMessage({
          id: "axleQty",
          defaultMessage: "Number of axles",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "axleRearQty",
        title: intl.formatMessage({
          id: "axleRearQty",
          defaultMessage: "Number of rear axles",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "axleAuxQty",
        title: intl.formatMessage({
          id: "axleAuxQty",
          defaultMessage: "Number of auxiliary axles",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "doorsQty",
        title: intl.formatMessage({
          id: "doorsQty",
          defaultMessage: "Doors quantity",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "odometerInitial",
        title: intl.formatMessage({
          id: "odometerInitial",
          defaultMessage: "Odometer initial",
        }),
        sorter: true,
        width: 170,
      },
      {
        dataIndex: "processDate",
        title: intl.formatMessage({
          id: "vehicles.table.lastUsedDate",
          defaultMessage: "Last used date",
        }),
        sorter: false,
        width: 190,
        render: (text) => {
          if (!text) return "";
          return moment(text).format("L");
        },
      },
      {
        dataIndex: "hierarchy.level1",
        title: intl.formatMessage({ id: "level.1", defaultMessage: "Level 1" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level2",
        title: intl.formatMessage({ id: "level.2", defaultMessage: "Level 2" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level3",
        title: intl.formatMessage({ id: "level.3", defaultMessage: "Level 3" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level4",
        title: intl.formatMessage({ id: "level.4", defaultMessage: "Level 4" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level5",
        title: intl.formatMessage({ id: "level.5", defaultMessage: "Level 5" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level6",
        title: intl.formatMessage({ id: "level.6", defaultMessage: "Level 6" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level7",
        title: intl.formatMessage({ id: "level.7", defaultMessage: "Level 7" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level8",
        title: intl.formatMessage({ id: "level.8", defaultMessage: "Level 8" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level9",
        title: intl.formatMessage({ id: "level.9", defaultMessage: "Level 9" }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "hierarchy.level10",
        title: intl.formatMessage({
          id: "level.10",
          defaultMessage: "Level 10",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "rentalCompanyName",
        title: intl.formatMessage({
          id: "rentalCompany",
          defaultMessage: "Rental company",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "contractReference",
        title: intl.formatMessage({
          id: "vehicles.rentalContractReference",
          defaultMessage: "Contract reference",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "contractConditions",
        title: intl.formatMessage({
          id: "vehicles.rentalContractConditions",
          defaultMessage: "Contract conditions",
        }),
        sorter: true,
        width: 200,
      },
      {
        dataIndex: "dateContract",
        title: intl.formatMessage({
          id: "vehicles.rentalContractDate",
          defaultMessage: "Contract date",
        }),
        sorter: true,
        width: 180,
        render: (text) => {
          if (!text) return "";
          return moment(text).format("L");
        },
      },
      {
        dataIndex: "dateStart",
        title: intl.formatMessage({
          id: "vehicles.rentalContractStart",
          defaultMessage: "Start date",
        }),
        sorter: true,
        width: 180,
        render: (text) => {
          if (!text) return "";
          return moment(text).format("L");
        },
      },
      {
        dataIndex: "dateEnd",
        title: intl.formatMessage({
          id: "vehicles.rentalContractEnd",
          defaultMessage: "Expiration date",
        }),
        sorter: true,
        width: 180,
        render: (text) => {
          if (!text) return "";
          return moment(text).format("L");
        },
      },
      {
        dataIndex: "agreementAmount",
        title: intl.formatMessage({
          id: "vehicles.rentalAgreementAmount",
          defaultMessage: "Agreement amount",
        }),
        sorter: true,
        width: 200,
        render: (val) => {
          const { intl } = this.props;
          const valueFormat = {
            style: "decimal",
            useGrouping: true,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          };
          return val ? (
            <span>{intl.formatNumber(val || 0, valueFormat)}</span>
          ) : (
            ""
          );
        },
      },
      {
        dataIndex: "observation",
        title: intl.formatMessage({
          id: "observations",
          defaultMessage: "Observations",
        }),
        sorter: true,
        width: 200,
      },
      {
        hidden: true,
        dataIndex: "_whitespace",
        title: "",
      },
    ];
  }

  getVehicleStatus(text, record) {
    const statusClassName =
      record.vehicleStatus?.vehicleStatusID === 2
        ? "inactive"
        : record.vehicleStatus?.vehicleStatusID === 0
          ? "disabled"
          : "active";
    return (
      <span className={`v3-tag ${statusClassName}`}>
        {capitalize(text) || "N/A"}
      </span>
    );
  }

  getOwnershipStatus(text, record) {
    const statusClassName =
      [1].indexOf(record.ownershipStatusID) >= 0
        ? "active"
        : [2].indexOf(record.ownershipStatusID) >= 0
          ? "disabled"
          : "inactive";
    return (
      <span className={`v3-tag ${statusClassName}`}>
        {capitalize(text) || "N/A"}
      </span>
    );
  }

  getData = (take, skip, sortProperty, sortDirection, search) => {
    const { intl, alert } = this.props;
    const { response, stateuid } = this.state;
    const { locale, company } = this.context;
    const companyID = company?.companyID || 0;

    let pageSize = take || response?.pageSize || 5;
    let pageIndex = !response?.data ? 0 : parseInt(skip / pageSize);

    const request = {
      pageIndex,
      pageSize,
      search: search ? search : response?.search ? response.search : "",
      sortProperty: sortProperty || "",
      sortDirection: sortDirection || "asc",
      cacheControl: stateuid,
      filters: {
        companyID: companyID,
        ...this.getPrefilters(),
      },
    };

    this.setState({ loading: true });

    this.fetchVehicles(companyID, locale, request)
      .then((response) => {
        this.mapResponseData(response);

        this.setState({
          ready: true,
          loading: false,
          error: false,
          response: response.data,
        });
      })
      .catch((error) => {
        this.setState({ ready: true, error: true, loading: false });
        handleAPI(error, alert, intl);
      });
  };

  fetchVehicles(companyID, locale, request) {
    return hubAPI.post(
      `/api/v1/Company/${companyID}/listvehiclesfrontend?culture=${locale}`,
      request,
    );
  }

  getPrefilters() {
    const { filters } = this.props;

    const allowedFilters = [
      "vehicleBrandID",
      "vehicleModelID",
      "vehicleSubTypeID",
      "costCenterID",
      "hierarchyID",
      "driverID",
      "vehicleTypeID",
      "vehicleVersionID",
      "vehicleStatusID",
      "ownershipStatusID",
      "vehicleLastThirtyDayID",
      "fleetTypeID",
      "mainHierarchyID",
    ];

    return allowedFilters.reduce((acc, filter) => {
      const value = filters[filter];
      if (Array.isArray(value) && value.length > 0) {
        acc[filter] = value.join(",");
      }
      return acc;
    }, {});
  }

  mapResponseData(response) {
    if (!this.mount) return;
    const { dashboardHandler, intl, widget } = this.props;
    const { currentLayouts } = dashboardHandler.getState();
    const widgetID = `${widget.dashboardWidgetID}`;
    const rowCount =
      (response.data.data || []).length < 5
        ? 5
        : (response.data.data || []).length;
    const minHeight = 292;
    const newHeight = ((rowCount - 5) * 57) / 2 + minHeight;

    for (let key in currentLayouts) {
      for (let i = 0; i < currentLayouts[key].length; i++) {
        if (currentLayouts[key][i].i === widgetID) {
          currentLayouts[key][i].h = Math.ceil(newHeight);
        }
      }
    }
    dashboardHandler.changeCurrentLayout(currentLayouts);

    const vs = vehicleStatuses.map((x) => ({
      ...x,
      vehicleStatusID: x.id,
      name: intl.formatMessage({
        id: `vehicles.vehicleStatusID.${x.id}`,
        defaultMessage: x.name,
      }),
    }));
    const os = ownershipStatuses.map((x) => ({
      ...x,
      ownershipStatusID: x.id,
      name: intl.formatMessage({
        id: `vehicles.ownershipStatusID.${x.id}`,
        defaultMessage: x.name,
      }),
    }));

    response.data.data.forEach((d) => {
      d.ownershipStatusID =
        d.ownershipStatusID !== null
          ? d.ownershipStatusID
          : d.ownFleet === false
            ? 2
            : 1;
      d.ownershipStatus =
        d.ownershipStatus !== null
          ? d.ownershipStatus
          : os.find((x) => x.ownershipStatusID === d.ownershipStatusID);
      d.vehicleStatus = vs.find(
        (x) => x.vehicleStatusID === (d.vehicleStatusID || 0),
      );

      if (d.hierarchy != null) {
        const updatedHierarchy = { ...d.hierarchy };

        d.hierarchyLevels.forEach((r, i) => {
          updatedHierarchy[`level${i + 1}`] = r.name;
        });

        d.hierarchy = updatedHierarchy;
      }
    });
  }

  componentDidMount() {
    const { company, locale } = this.context;
    const { visibleColumns } = this.state;
    const { filters } = this.props;
    this.mount = true;

    let language = (locale || "en-US").substring(0, 2);
    if (language !== "en")
      import(`moment/locale/${language}.js`).then(() => {
        moment.locale(language);
      });

    if (company?.companyID) this.verifySingleRegistry(company.companyID);

    this.setState(
      {
        filters,
        uid: generateUID,
        companyID: company?.companyID || 0,
        visibleColumns:
          !!getHardFilter("vehicles-v2-table-columns") &&
            isArray(getHardFilter("vehicles-v2-table-columns"))
            ? [...getHardFilter("vehicles-v2-table-columns")]
            : visibleColumns,
      },
      () => {
        this.prepareColumnSet();
      },
    );
  }

  verifySingleRegistry(companyID) {
    isSingleRegistryVehicleActive(companyID).then((res) =>
      this.setState({ singleRegistryIsActive: res.data }),
    );
  }

  insertVehicleButtonRender(company) {
    return (
      <Link
        className="v3-button"
        to={"/app/:companyID/vehicle/insert".replace(
          ":companyID",
          company?.companyID,
        )}
      >
        <FormattedMessage
          id="vehicles.table.add"
          defaultMessage="New vehicle"
        />
      </Link>
    );
  }

  componentDidUpdate() {
    if (!this.mount) return;

    const { company } = this.context;
    const { companyID, filters, stateuid, response } = this.state;

    const currentCompanyID = company?.companyID || 0;

    if (currentCompanyID !== companyID) {
      this.setState(
        {
          companyID: currentCompanyID,
          filters: this.props.filters,
          singleRegistryIsActive: false,
        },
        () => {
          if (currentCompanyID > 0) {
            this.verifySingleRegistry(currentCompanyID);
          }
        },
      );
    } else if (filters !== this.props.filters) {
      this.setState({ filters: this.props.filters });
    }

    if (!!this.props.stateuid && stateuid !== this.props.stateuid) {
      this.setState(
        {
          stateuid: this.props.stateuid,
          filters: this.props.filters,
        },
        () => {
          this.getData(
            response?.pageSize || 5,
            0,
            response?.sortProperty,
            response?.sortDirection || "asc",
            response?.search || "",
          );
        },
      );
    }
  }

  componentWillUnmount() {
    this.mount = false;
  }

  onTableChange = (_, __, sorter) => {
    const { response } = this.state;

    var sortDirection = sorter?.order || "asc";
    var sortProperty = (sorter?.field || "plate").includes(".")
      ? (sorter?.field || "plate").split(".")[0] || "plate"
      : sorter?.field || "plate";

    this.getData(
      response?.pageSize || 5,
      (response?.pageIndex || 0) * (response?.pageSize || 5),
      sortProperty,
      sortDirection,
    );
  };

  onSearchEnter = (e) => {
    const { response } = this.state;
    const value = e.target.value;

    if (response?.search !== value) {
      response.search = value;
      this.getData(
        response?.pageSize || 5,
        0,
        response?.sortProperty,
        response?.sortDirection,
        value,
      );
    }
  };

  onDownload = () => {
    const { company, locale } = this.context;
    const { loading, visibleColumns } = this.state;
    const { intl, alert, filters } = this.props;
    if (!!loading) return;

    let columns = !visibleColumns ? this.columnsSet : visibleColumns;

    const allowedFilters = [
      "vehicleBrandID",
      "vehicleModelID",
      "vehicleSubTypeID",
      "costCenterID",
      "hierarchyID",
      "driverID",
      "vehicleTypeID",
      "vehicleVersionID",
      "vehicleStatusID",
      "ownershipStatusID",
      "vehicleLastThirtyDayID",
      "fleetTypeID",
    ];

    //54613 [Improvement] – Tagging specification
    window.dataLayer.push({
      event: "hero_edenred_interaction",
      detail: "veiculos:baixar",
      option: "bot",
    });

    const preFilters = {};
    allowedFilters.forEach((filter) => {
      if (
        !!filters[filter] &&
        isArray(filters[filter]) &&
        filters[filter].length > 0
      )
        preFilters[filter] = filters[filter].join(",");
    });

    this.setState({ loading: true });
    return new Promise((resolve, reject) => {
      let params = {
        style: "withdata",
        culture: locale,
        isFileOnly: true,
        columns: columns,
        filters: { ...preFilters },
      };

      const access_token = localStorage.getItem("access_token");
      const url =
        process.env.REACT_APP_CTLG_URL +
        `/api/v1/Company/${company?.companyID || 0}/vehiclefiledownload?culture=${locale}`; // + params.toString()
      let headers = new Headers();
      headers.append("Authorization", `Bearer ${access_token}`);
      headers.append("Content-Type", "application/json");
      const requestOptions = {
        method: "Post",
        headers: headers,
        redirect: "follow",
        body: JSON.stringify(params),
      };
      fetch(url, requestOptions)
        .then((response) => response.blob())
        .catch((e) => {
          this.setState({ loading: false });
          handleAPI(e, alert, intl);
          reject(e);
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          a.download = `${intl.formatMessage({ id: "vehicles", defaultMessage: "Vehicles" })}.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();

          this.setState({ loading: false });
          resolve(blob);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getFamilyTreeHierarchies = (array, parent = "") => {
    let familyTreeHierarchies = [];
    for (const hierarchy of array) {
      const name = hierarchy.name;
      const parentHierarchy = parent ? `${parent} > ${name}` : name;

      familyTreeHierarchies.push({
        parentHierarchy: parentHierarchy,
        hierarchyID: hierarchy.hierarchyID,
      });

      if (hierarchy.children && hierarchy.children.length > 0) {
        const childrenNames = this.getFamilyTreeHierarchies(
          hierarchy.children,
          parentHierarchy,
          familyTreeHierarchies,
        );
        familyTreeHierarchies.push(...childrenNames);
      }
    }
    return familyTreeHierarchies;
  };
}

class VehicleTableCard extends VehicleTableCardBase {
  render() {
    const { widget, intl } = this.props;
    const { company } = this.context;
    const {
      loading,
      ready,
      response,
      search,
      visibleColumns,
      showCustomizeColumns,
    } = this.state;

    const columns = [...visibleColumns, "_whitespace"].map((c) =>
      this.columnsSet.find((x) => x.dataIndex === c),
    );

    const actionsColumn = {
      title: "",
      key: "__actions",
      fixed: "right",
      width: 56,
      render: (_, record) => {
        return (
          <Dropdown
            placement="bottomRight"
            overlay={() => (
              <ActionsColumnMenu
                vehicleID={record.vehicleID}
                companyID={company.companyID}
                editUrl={this.props.editUrl}
                reviewUrl={this.props.reviewUrl}
              />
            )}
          >
            <button className="icon-button">
              <DV3EllipseIcon />
            </button>
          </Dropdown>
        );
      },
    };

    if (!ready || !this.columnsSet) {
      return (
        <Suspense fallback={<div></div>}>
          <div className={`${widget.componentKey}`}></div>
          <LoadInWidget />
        </Suspense>
      );
    }

    return (
      <Suspense fallback={<div></div>}>
        <div className={`${widget.componentKey}`}>
          <div className="separator-row" style={{ marginTop: "16px" }}></div>
          <div className="filters-area">
            <div className="filters-area-search">
              <Input
                value={search}
                onChange={({ target: { value } }) =>
                  this.setState({ search: value })
                }
                onPressEnter={this.onSearchEnter}
                placeholder={intl.formatMessage({
                  id: "vehicles.table.search",
                  defaultMessage: "Search",
                })}
                addonAfter={
                  <DV3SearchIcon
                    onClick={() =>
                      this.onSearchEnter({ target: { value: search } })
                    }
                  />
                }
              />
            </div>
            <div className="filters-area-options">
              <div className="header-filters">
                <div className="header-filters-option">
                  <label className="option-label">
                    <FormattedMessage
                      id="vehicles.table.customize"
                      defaultMessage="Customize columns"
                    />
                  </label>
                  <button
                    className="icon-button custom-svg-cog"
                    style={{ position: "relative" }}
                    onClick={() =>
                      this.setState({ showCustomizeColumns: true }, () => {
                        //54613 [Improvement] – Tagging specification
                        window.dataLayer.push({
                          event: "hero_edenred_interaction",
                          detail: "veiculos:personalizar_colunas",
                        });
                      })
                    }
                  >
                    <DV3CogIcon />
                  </button>
                </div>

                <div className="header-filters-option">
                  <label className="option-label">
                    <FormattedMessage
                      id="home.download"
                      defaultMessage="Download"
                    />
                  </label>
                  <button
                    className="icon-button"
                    onClick={() => {
                      this.onDownload();
                    }}
                  >
                    <DV3ExcelIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="table-area">
            <Table
              pagination={false}
              scroll={{ x: 500 }}
              dataSource={response?.data || []}
              columns={[...columns.filter((x) => !!x), actionsColumn]}
              onChange={this.onTableChange}
              rowKey={"vehicleID"}
            />

            <CustomPaginator
              pagerInfo={response}
              onChange={(current) =>
                this.getData(
                  response?.pageSize || 5,
                  (current > 0 ? current - 1 : 0) * (response?.pageSize || 5),
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
              onShowSizeChange={(current, size) =>
                this.getData(
                  size,
                  (current > 0 ? current - 1 : 0) * size,
                  response?.sortProperty,
                  response?.sortDirection || "asc",
                )
              }
            />
          </div>
          <VehicleTableCardActions
            dashboardWidgetID={widget?.dashboardWidgetID || 0}
          >
            <div className="on-title-actions">
              <Link
                className="v3-button"
                to={`/app/:companyID/vehicle/upload?skip_solutions=${!this.state.singleRegistryIsActive}`.replace(
                  ":companyID",
                  company?.companyID,
                )}
              >
                <FormattedMessage
                  id="vehicles.table.upload"
                  defaultMessage="Batch Upload"
                />
              </Link>
              {this.insertVehicleButtonRender(company)}
              {this.state?.singleRegistryIsActive && (
                <Link
                  className="v3-button"
                  to={`/app/:companyID/vehicle/single-registry/sync-history`.replace(
                    ":companyID",
                    company?.companyID,
                  )}
                >
                  <FormattedMessage
                    id="vehicles.table.syncHistory"
                    defaultMessage="Sync & History"
                  />
                </Link>
              )}
            </div>
          </VehicleTableCardActions>
        </div>

        {loading && <LoadInWidget />}

        <CustomColumns
          visible={showCustomizeColumns}
          columnsSet={this.columnsSet}
          visibleColumns={visibleColumns}
          onCancel={() => this.setState({ showCustomizeColumns: false })}
          onOk={(v) => {
            if (v.length <= 0) return;
            this.setState(
              { visibleColumns: v, showCustomizeColumns: false },
              () => {
                setHardFilter("vehicles-v2-table-columns", v);
              },
            );
          }}
        />
      </Suspense>
    );
  }
}

VehicleTableCard.contextType = HUBContext;
export default withAlert()(withStyles(styles)(injectIntl(VehicleTableCard)));
